export default {
    state: {
        list: null,

        count: null,

        establishments: null,

        boundEstablishments: null,

        filters: {
            search: "",
            orderBy: "nome",
            desc: false,
        },
    },

    mutations: {
        ADVERTISERS_SET_LIST(state, list) {
            state.list = list;
        },

        ADVERTISERS_SET_COUNT(state, count) {
            state.count = count;
        },

        ADVERTISERS_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value,
            };
        },

        ADVERTISERS_RESET_FILTERS(state) {
            state.filters = {
                search: "",
                orderBy: "data",
                desc: true,
                date: {
                    min: null,
                    max: null,
                },
            };
        },

        ADVERTISERS_SET_ESTABLISHMENTS(state, establishments) {
            state.establishments = establishments;
        },

        ADVERTISERS_CLEAR_ESTABLISHMENTS(state) {
            state.establishments = null;
        },

        ADVERTISERS_SET_BOUND_ESTABLISHMENTS(state, establishments) {
            state.boundEstablishments = establishments;
        },

        ADVERTISERS_CLEAR_BOUND_ESTABLISHMENTS(state) {
            state.boundEstablishments = null;
        },
    },
};
